const BxfChatPromptBoxConstants = {
    CONTAINER: 'bxf-chat-prompt-box__container',
    CONTAINER_CONTENT: 'bxf-chat-prompt-box__container-content',
    TEXT_BOX_CONTAINER: 'bxf-chat-prompt-box__text-box-container',
    TEXT_BOX_CONTAINER_FOCUSED: 'bxf-chat-prompt-box__text-box-container--focused',
    TEXT_BOX_CONTAINER_DISABLED: 'bxf-chat-prompt-box__text-box-container--disabled',
    TEXT_BOX_TOOLBAR_CONTAINER: 'bxf-chat-prompt-box__text-box-toolbar-container',
    TEXT_AREA: 'bxf-chat-prompt-box__text-area',
    CHAR_COUNTER: 'bxf-chat-prompt-box__char-counter',
    CHAR_COUNTER_MAX_REACHED: 'bxf-chat-prompt-box__char-counter--max-reached',
    CHAR_COUNTER_DISABLED: 'bxf-chat-prompt-box__char-counter--disabled',
    SUBMIT_BUTTON: 'bxf-chat-prompt-box__submit-button',
    SUBMIT_BUTTON_DISABLED: 'bxf-chat-prompt-box__submit-button--disabled',
    DISCLAIMER_TEXT: 'bxf-chat-prompt-box__disclaimer-text',
    DISCLAIMER_TEXT_DISABLED: 'bxf-chat-prompt-box__disclaimer-text--disabled',
    CHAT_PROMPT_BOX: 'bxf-chat-prompt-box',
    CONTAINER_COLUMN: 'bxf-chat-prompt-box__container-column',
    SUBMIT_BUTTON_ARIA_LABEL: 'Submit Text',
    PLACEHOLDER_DEFAULT: 'What would you like to know?',
    DEFAULT_TEXT_AREA_HEIGHT: '1.5rem',
};

export { BxfChatPromptBoxConstants as B };
